import { render } from "./InjuryAgeAlysis.vue?vue&type=template&id=456df684&scoped=true"
import script from "./InjuryAgeAlysis.vue?vue&type=script&lang=js"
export * from "./InjuryAgeAlysis.vue?vue&type=script&lang=js"

import "./InjuryAgeAlysis.vue?vue&type=style&index=0&id=456df684&lang=scss&scoped=true"
import "./InjuryAgeAlysis.vue?vue&type=style&index=1&id=456df684&lang=scss&scoped=true"
import "./InjuryAgeAlysis.vue?vue&type=style&index=2&id=456df684&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456df684"]])

export default __exports__